import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { LanguageProvider } from './localization/LanguageProvider';
import { translationMessages } from './localization/i18n';
import './fonts/EuclidCircularA-Regular-WebS.ttf';
import { Intercom } from './services/intercom';
import { WithAuthenticatedUser } from './services/authenticatedUser/WithAuthenticatedUser';

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container #root not found');
}

createRoot(container).render(
    <React.StrictMode>
        <LanguageProvider messages={translationMessages}>
            <BrowserRouter>
                <WithAuthenticatedUser>
                    <App />
                    <Intercom />
                </WithAuthenticatedUser>
            </BrowserRouter>
        </LanguageProvider>
    </React.StrictMode>
);
